import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../data/mock';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('swg-language');
    return saved || 'en';
  });

  useEffect(() => {
    localStorage.setItem('swg-language', language);
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  // Pick the localized variant from { en, fr } objects, or return as-is.
  const pick = (field) => {
    if (field == null) return field;
    if (typeof field === 'object' && !Array.isArray(field) && ('en' in field || 'fr' in field)) {
      return field[language] ?? field.en ?? field.fr;
    }
    return field;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'fr' : 'en');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t, pick }}>
      {children}
    </LanguageContext.Provider>
  );
};
